export type FloatingPanelPosition = { left: number; top: number };

const GAP = 6;
const MARGIN = 8;

// The cards clip their content, so the detail panels are fixed to the viewport beside the element they describe.
const place = (anchor: DOMRect, width: number, height: number, side: "left" | "right"): FloatingPanelPosition => {
    const wanted = side === "right" ? anchor.right + GAP : anchor.left - GAP - width;
    return {
        left: Math.max(MARGIN, Math.min(window.innerWidth - width - MARGIN, wanted)),
        top: Math.max(MARGIN, Math.min(window.innerHeight - height - MARGIN, anchor.top)),
    };
};

export const floatingPanel = { place };
